module.exports = __webpack_public_path__ + "public/images/icon-schedule.c1bc733d506ee6e1b092dc8f7424a09f.svg";